import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function MembershipCancel() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-6" data-testid="membership-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-lg text-center"
      >
        <img src="/assets/logo.png" alt="" className="mx-auto h-24 w-24 rounded-full object-cover" />
        <h1 className="mt-8 font-serif text-4xl tracking-tight md:text-5xl" data-testid="cancel-heading">
          No hard <em className="text-wine">feelings.</em>
        </h1>
        <p className="mt-6 text-sm leading-relaxed text-ink/65 md:text-base">
          Checkout was cancelled before anything was charged. Your free membership
          is untouched — Premium will be waiting whenever you are.
        </p>
        <Link
          to="/"
          data-testid="cancel-home-link"
          className="mt-10 inline-block rounded-full bg-wine px-8 py-4 text-sm uppercase tracking-widest text-paper transition-colors duration-300 hover:bg-ink"
        >
          Back to the club
        </Link>
      </motion.div>
    </main>
  );
}
